module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site"
    }
  }, [_c('navbar', {
    attrs: {
      "color": _vm.navbarColor
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-page",
      "mode": "out-in"
    },
    on: {
      "before-leave": function($event) {
        _vm.colorize(true, 'begin')
      },
      "before-enter": function($event) {
        _vm.colorize(true, 'middle')
      },
      "after-enter": function($event) {
        _vm.colorize(false, 'end')
      }
    }
  }, [_c('router-view', {
    staticClass: "wrap",
    on: {
      "init": _vm.changePage,
      "end-loading": _vm.endLoading
    }
  })], 1), _c('footerbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.footerColor),
      expression: "!!footerColor"
    }],
    attrs: {
      "color": _vm.footerColor
    }
  }), _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }],
    attrs: {
      "color": _vm.navbarColor
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22eb6f9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 42
// module chunks = 7